export class DocumentWorksheetApi {
  #http;

  constructor(http) {
    this.#http = http;
  }

  /**
   * POST /api/document-types/{documentTypeId}/worksheet
   * Creates (or updates in place) the single worksheet document for this doc type on the
   * loan and writes the authoritative extraction-field values. `completed` marks the
   * worksheet as finalized. `values` is the extraction-results array produced by
   * getExtractionFieldsToSend. `tables` (`{ fieldId, rows: [{ values }] }`, optional) are the
   * rows of the worksheet's tables (LEN-194: the Chattel Funding Worksheet's disbursements).
   * `calculatedValues` (`{ name, value }`, optional) is a display-only snapshot printed on the
   * generated PDF.
   */
  async saveWorksheet({
    documentTypeId,
    applicationId,
    loanId,
    values,
    tables,
    completed,
    calculatedValues,
  }) {
    return this.#http.post(`/api/document-types/${documentTypeId}/worksheet`, {
      applicationId,
      loanId,
      values,
      tables,
      completed,
      calculatedValues,
    });
  }
}
